import { render, staticRenderFns } from "./UserActivityStats.vue?vue&type=template&id=529a4dcc&scoped=true"
import script from "./UserActivityStats.vue?vue&type=script&lang=js"
export * from "./UserActivityStats.vue?vue&type=script&lang=js"
import style0 from "./UserActivityStats.vue?vue&type=style&index=0&id=529a4dcc&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "529a4dcc",
  null
  
)

export default component.exports